import { useState, useEffect } from 'react'
import { Container, Grid, TextField, Button, Typography, createTheme, Box, Link } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import AppAppBar2 from '../components/AppBar2'
import ProductHeroLayout from '../components/ProductHeroLayout';
import { minHeight, palette } from '@mui/system'
import { useFetchNoUser } from '../hooks/useFetchNoUser'
import CircularProgress from '@mui/material/CircularProgress';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import PlaceIcon from '@mui/icons-material/Place';
export default function ContactUs() {




    const [backgroundImage, setBackgroundImage] = useState('../img/BannerDistance.jpg')




    const navigate = useNavigate()









    return (

        <>

            <AppAppBar2 />
            <ProductHeroLayout
                fullWidth
                sxBackground={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundColor: '#7fc7d9', // Average color of the background image.
                    fullWidth: '90vh',
                    transition: 'background 3s linear',
                }}
            >

                <Container maxWidth="sm" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                    <Box fullWidth
                        sxBackground={{

                            backgroundColor: 'secondary ', // Average color of the background image.
                            fullWidth: 'calc(85vh)',
                            transition: 'background 3s linear',
                            marginTop: 0,


                        }}>


                        <Box mb={10} />
                        <Typography
                            variant="h3"
                            color="primary.main"
                            component="h2"
                            gutterBottom

                        >
                            Contact Us
                        </Typography>

                        <Box mb={5} />

                        <Typography
                            variant="body2"
                            color="primary.main"
                            component="p"
                            gutterBottom

                        >
                            Are you looking for more information on our products and services?
                        </Typography>

                        <Box mb={3} />


                        <Typography
                            variant="body2"
                            color="primary.main"
                            component="p"
                            gutterBottom

                        >
                            Give one of our trained Student Advisors a call on: <a href="tel:+27117067775">+27 11 706 7775.</a>
                        </Typography>

                        <Typography
                            variant="body2"
                            color="primary.main"
                            component="p"
                            gutterBottom

                        >


                            Alternatively, you can email all your queries to <a href="mailto:admin@bidc.co.za">admin@bidc.co.za</a> and we will get back to you as soon as possible.
                        </Typography>

                        <Typography
                            variant="body2"
                            color="primary.main"
                            component="p"
                            gutterBottom

                        >


                            Address:  <a href="https://share.google/oK8uHiu3NNj1rkiNp" target="_blank">130 Bryanston Drive, Sandton, 2191 </a>
                        </Typography>


                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4410.633929778823!2d28.013447987197893!3d-26.049410698814466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e95740a7b3a46a7%3A0xb3cbba29034be839!2sBritish%20International%20College!5e1!3m2!1sen!2sza!4v1750858920229!5m2!1sen!2sza" width="300" height="200" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                        <Typography
                            variant="body2"
                            color="primary.main"
                            component="p"
                            gutterBottom

                        >
                            <a href="tel:+27117067775"><LocalPhoneIcon /> </a><a href="mailto:admin@bidc.co.za"><EmailIcon /></a> <a href="https://share.google/oK8uHiu3NNj1rkiNp" target="_blank"><PlaceIcon /></a>
                        </Typography>

                        <Box mb={3} />


                        <Box mb={15} />
                    </Box>
                </Container>
            </ProductHeroLayout>
        </>
    )
}
